export default function YesNo({ id, name }) {
  return (
    <div className="whitespace-nowrap" key={id}>
      {name}
    </div>
  );
}
